import { states, provinces } from "./location-utils";

export const getPostPaymentUrl = (componentDomain, status) => {
  if (status === "failure")
    return `${window.location.origin}/apps/forms/#/${componentDomain}/failure/{0}`;
  return `${window.location.origin}/apps/forms/#/${componentDomain}/confirmation/{0}`;
};

export const generateRecaptchaToken = actionName => {
  return new Promise(resolve => {
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(
        process.env.VUE_APP_RECAPTCHA_V3_KEY,
        { action: actionName }
      );
      resolve(token);
    });
  });
};

export const parseStringPhoneNumber = stringPhoneNumber => {
  let sanitizedPhoneNumber = null;
  if (stringPhoneNumber !== "") {
    if (typeof stringPhoneNumber === "string") {
      let tempPhoneNumber = stringPhoneNumber;
      sanitizedPhoneNumber = Number(tempPhoneNumber.replace(/[^0-9]/g, ""));
    } else {
      sanitizedPhoneNumber = stringPhoneNumber;
    }
  }
  return sanitizedPhoneNumber;
};

export const getSelectedOption = (value, key, options) => {
  const selectedOption = options.find(option => {
    let optionValue = option?.[key] || option;
    let valueKey = value?.[key] || value;
    if (typeof optionValue === "number") {
      optionValue = optionValue.toString();
    }
    if (typeof valueKey === "number") {
      valueKey = valueKey.toString();
    }

    return (
      (typeof optionValue === "string" ? optionValue : "")
        .trim()
        .toLowerCase() ==
      (typeof valueKey === "string" ? valueKey : "").trim().toLowerCase()
    );
  });

  return selectedOption;
};

export const validateDecimal = value => {
  value = value.replace(/[^0-9.]/g, "");
  return value;
};

export const getMappedProvince = value => {
  const selectedProvince = [...states, ...provinces]?.find(
    province => province.label === value || province.value === value
  );
  return selectedProvince?.label || value;
};
